import { useSearchParams } from "#routers/hooks";
import { MeasurementTypeViewFilterArea } from "#src/batteries-included-components/FilterAreas/MeasurementTypeFilterAreas";
import { UnitConfigTablePanel } from "#src/batteries-included-components/Panels/TablePanels/UnitConfigTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { Page, Tab } from "@validereinc/common-components";
import { UnitConfigurationPreference } from "@validereinc/domain";
import React from "react";
import {
  MEASUREMENT_TYPES_SETTINGS_BREADCRUMB,
  MEASUREMENT_TYPE_TITLE,
} from ".";
import { SETTINGS_BREADCRUMB } from "..";

export const MeasurementTypePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const DEFAULT_TAB_KEY = "company";

  const [measurementTypeFilterConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-state"],
      ["measurement-types"]
    );

  return (
    <Page
      title={MEASUREMENT_TYPE_TITLE}
      breadcrumbs={[SETTINGS_BREADCRUMB, MEASUREMENT_TYPES_SETTINGS_BREADCRUMB]}
      activeTabKey={searchParams?.tab ?? DEFAULT_TAB_KEY}
      onActiveTabKeyChange={(tabKey: string) => {
        setSearchParams({ tab: tabKey });
      }}
    >
      <Tab
        title={"My Company"}
        tabKey="company"
      >
        <UnitConfigTablePanel
          unitConfigurationPreference={UnitConfigurationPreference.COMPANY}
          storageKey={measurementTypeFilterConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
          filterComponent={
            <MeasurementTypeViewFilterArea
              filterConfigStorageKey={measurementTypeFilterConfigStorageKey}
            />
          }
        />
      </Tab>
      <Tab
        title={"My User"}
        tabKey="user"
      >
        <UnitConfigTablePanel
          unitConfigurationPreference={UnitConfigurationPreference.USER}
          storageKey={measurementTypeFilterConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
          filterComponent={
            <MeasurementTypeViewFilterArea
              filterConfigStorageKey={measurementTypeFilterConfigStorageKey}
            />
          }
        />
      </Tab>
    </Page>
  );
};
